import { DownloadFormat } from 'records'

export const downloadFormats: Record<string, DownloadFormat> = {
    json: {
        format: 'json',
    },
    xml: {
        format: 'xml',
    },
    ISO_2709: {
        format: 'ISO_2709',
        extension: 'mrc',
    },
}

export const downloadFormatDropdownItems = [
    {
        key: 'xml',
        label: 'XML',
    },
    {
        key: 'json',
        label: 'JSON',
    },
    {
        key: 'ISO_2709',
        label: 'ISO 2709',
    },
]
